<app-material>
    <div class="header" header>
        <div class="title">
            <h2>{{ 'atom.tool-returns.inspect-details.scanner.label' | translate }}</h2>
        </div>
        <div class="details">
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.toolRequest' | translate"
                [value]="toolReturn.toolRequest?.name">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.facility' | translate"
                [value]="toolReturn.facility?.name">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.createdBy' | translate"
                [value]="toolReturn.createdBy?.fullName">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.createdDate' | translate"
                [value]="toolReturn.createdDate">
            </app-display-label>
        </div>
    </div>
    <div class="body" body>
        <form [formGroup]="inspectForm">
            <app-tool-inspect-tree
                [isScanListenerActive]="toolScanActive"
                [labelText]="'atom.tool-returns.inspect-details.scanner.label' | translate"
                [emptyMessage]="'atom.tool-returns.inspect-details.scanner.emptyText' | translate"
                [formControl]="inspectForm.controls['scannedTools']"
                [showErrors]="showValidations"
                [isMaterial]="true"
                [isScanEnabled]="toolScanActive"
                [items]="toolReturn.returnTools"
                (itemNotFound)="onItemNotFound($event)"
                (toolSelect)="onToolScanned($event)"
                (toolsSelected)="onToolsScanned($event)"
                (rowAlertClick)="onRowAlertClick($event)">
            </app-tool-inspect-tree>
        </form>
    </div>
    <div class="footer" footer>
        <app-button
            type="simple"
            (clicked)="onBackPressed()">{{ 'generic.buttons.back' | translate }}
        </app-button>
        <div class="buttons">
            <app-button
                type="primary"
                class="approve-button"
                [disabled]="inspectForm.invalid && showValidations || hasConfirmationInProgress"
                (clicked)="approveToolReturn()">{{ 'generic.buttons.approveForLift'| translate }}
            </app-button>
            <app-button *ngIf="this.toolReturn.hasSeveralReturnOptions"
                        type="primary"
                        class="approve-button"
                        [disabled]="inspectForm.invalid && showValidations || hasConfirmationInProgress"
                        (clicked)="approveToolReturnForLine()">{{ 'generic.buttons.approveForLine'| translate }}
            </app-button>
        </div>
    </div>
</app-material>
